// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.dialog-card {\n  position: absolute;\n  top: -10%;\n}\n.payout-upload-excel-file .el-icon-upload{\n    font-size: 34px;\n    color: #D3D7DF;\n    margin: 28px 0 16px;\n    line-height: 1;\n}\n", ""]);
// Exports
module.exports = exports;
